// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreatorsSearchContent-text {
  color: #4c5567;
  color: var(--color_neutral_800, #4c5567);
  font-size: 14px;
  line-height: 160%; /* 22.4px */
  width: 522px;
}
.CreatorsSearchContent-dropdownsContainer {
  display: flex;
  align-items: center;
  gap: 32px;
}`, "",{"version":3,"sources":["webpack://./src/components/GenerateWinninAIReportUseCaseModal/components/CreatorsSearchContent/index.scss"],"names":[],"mappings":"AACE;EACE,cAAA;EAAA,wCAAA;EACA,eAAA;EACA,iBAAA,EAAA,WAAA;EACA,YAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AADJ","sourcesContent":[".CreatorsSearchContent {\n  &-text {\n    color: var(--color_neutral_800, #4c5567);\n    font-size: 14px;\n    line-height: 160%; /* 22.4px */\n    width: 522px;\n  }\n\n  &-dropdownsContainer {\n    display: flex;\n    align-items: center;\n    gap: 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
